export default "__VITE_ASSET__YP0e2csK__"